<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import PagePreviewColumn from "../../components/PagePreviewColumn.svelte";
    import PagePreviewContainer from "../../components/PagePreviewContainer.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import Systeme from "../../icons/SystemsIcon.svelte";
    import Krankenwagen from "../../icons/KrankenwagenIcon.svelte";
    import Alarm from "../../icons/AlarmIcon.svelte";
    import Funk from "../../icons/FunkIcon.svelte";
    import Reparaturen from "../../icons/RepairIcon.svelte";
    import Server from "../../icons/ServerIcon.svelte";
    import ProjectPreviews from "../../components/ProjectPreviews.svelte";
    import Animate from "../../components/Animate.svelte";
    import PagePreviews from "../../components/PagePreviews.svelte";

    import type { ProjectPreview } from "../../components/ProjectPreviews.svelte";

    import type { Project } from "../../components/ProjectPreviews.svelte";
    import { ProjectCateories } from "../../components/ProjectPreviews.svelte";
    import { t } from "../../helpers/translation";

    const loadData = async (): Promise<Project[]> => {
        const data: Project[] = await fetch("/api/projects")
            .then((data) => data.json())
            .then((data) => {
                data.forEach((event) => {
                    if (event.startdate && event.enddate)
                        event.date =
                            new Date(event.startdate).toLocaleDateString() +
                            " - " +
                            new Date(event.enddate).toLocaleDateString();
                    else if (event.startdate)
                        event.date = new Date(
                            event.startdate,
                        ).toLocaleDateString();
                    else if (event.enddate)
                        event.date = new Date(
                            event.enddate,
                        ).toLocaleDateString();
                    else event.date = "";
                });
                data = data.filter(
                    (proj) =>
                        proj.projectcategoryid ==
                        ProjectCateories.SPRACH_DATENFUNK,
                );
                return data;
            });

        return data ? Promise.resolve<Project[]>(data) : Promise.reject(null);
    };
</script>

<LightTheme />

<Hero
    headline={$t("page.sprachdaten.hero.headline")}
    small
    vid="https://liveicom.azureedge.net/sinus/vid/sinus_sprach_datenfunk.mp4"
/>

<Container>
    <Headline>
        {@html $t("page.sprachdaten.headline")}
    </Headline>
    <Subline>
        {@html $t("page.sprachdaten.subline")}
    </Subline>
    <p>
        {@html $t("page.sprachdaten.p.1")}
    </p>
    <Gap />
    <Animate>
        <Btn arrow href="kontakt">
            {@html $t("page.sprachdaten.btn.contact")}
        </Btn>
    </Animate>
    <Gap height="4rem" />

    <Dropdown
        heading={$t("page.sprachdaten.dropdown.infomaterial")}
        justify_heading="left"
        auto_open
    >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/IHM-Status-Panel-sw-grafik.pdf"
            >IHM Status Panel Broschüre</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/Digitalfunk-BOS_print_neu.pdf"
            >Digitalfunk BOS Broschüre</Btn
        >

        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/mxp600_brochure_deu.pdf"
            >Motorola MXP600 Hauptbroschüre</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/mxp600_specifications_sheet_deu.pdf"
            >Motorola MXP600 Gerätespezifikationen</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/mxp600_accessories_catalogue.pdf"
            >Motorola MXP600 Zubehör</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/mxp600_tetra_devices_software_features_catalog-TETRA-Softwarefunktionen.pdf"
            >Motorola MXP600 Softwarefunktionen</Btn
        >
        <Btn
            pdf
            small
            href="https://liveicom.azureedge.net/sinus/files/mxp600_On-The-Air-Programmierung_Datenblatt.pdf"
            >Motorola MXP600 Over-The-Air-Programmierung</Btn
        >
    </Dropdown>
    <Gap height="4rem" />
    <ProjectPreviews
        data_callback={loadData}
        url_base="projekte"
        show_empty_message={false}
    />
    <Gap height="4rem" />
</Container>

<PagePreviews leitstellen wachen_elw digital_alarm />

<center>
    <Btn arrow href="kontakt">
        {@html $t("page.sprachdaten.btn.projectrequest")}
    </Btn>
</center>
